import React, { useContext, useEffect } from 'react';

import { GramUnits, LiquidScreen, UnitType } from '../../../../types';

import CalculatorComponent from '../../../../components/CalculatorComponent';

import { LiquidContext } from '../../../../contexts/LiquidProvider';
import { CalculatorNavigationContext } from '../../../../contexts/CalculatorNavigationProvider';
import { CalculatorContext } from '../../../../contexts/CalculatorProvider';

function LiquidDraperFirstScreen(): React.ReactElement {
 const { setBackButtonText, setNextButtonAction, setBackButtonAction } =
  useContext(CalculatorNavigationContext);

 const {
  setCurrentScreen,
  onValueChange,
  onSelectChange,
  getSelectInitialState,
  getValueInitialState,
 } = useContext(LiquidContext);

 const { setHasCheckbox, setQuestion, setUnitTypes } =
  useContext(CalculatorContext);

 const unitTypes = GramUnits.filter(unit =>
  [UnitType.Gram, UnitType.Kilogram].includes(unit.description),
 );

 const setNavigationProps = () => {
  const setBackButtonProps = () => {
   setBackButtonText('Forrige');
   setBackButtonAction(() => () => setCurrentScreen(LiquidScreen.First));
  };
  const setNextButtonProps = () => {
   setNextButtonAction(() => () => setCurrentScreen(LiquidScreen.Third));
  };
  setBackButtonProps();
  setNextButtonProps();
 };

 const setCalculatorProps = () => {
  setHasCheckbox(false);
  setQuestion('Hvor mye veier pasienten?');
  setUnitTypes(unitTypes);
 };

 useEffect(() => {
  setNavigationProps();
  setCalculatorProps();
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, []);

 return (
  <CalculatorComponent
   onValueChange={onValueChange}
   onSelectChange={onSelectChange}
   valueInitialState={getValueInitialState()}
   selectInitialState={getSelectInitialState()}
  />
 );
}

export default LiquidDraperFirstScreen;
